<div class="swiper-container">
                    <ng-content></ng-content>
                </div>